import { useApi } from "../../../swr/useApi";
import { api } from "../../api_client";

export interface WarrantyOption {
  id: number;
  /** product.product (variant) id — use this for sale order lines. */
  variantId: number | null;
  name: string;
  price: number | null;
  warrantyId: number | null;
  warrantyTypeId: number | null;
  warrantyProviderId: number | null;
  description: string | null;
}

/**
 * Fetches the warranty SKUs offered for a given product template id (template's
 * `compatible_warranty_ids`). Used by the checkout warranty modal to render
 * the per-product selector. Returns an empty array if the product has no
 * warranties attached.
 *
 * The generated API client doesn't expose this endpoint until
 * `npm run generate:api` runs after the BE module ships.
 */
export function useProductWarrantyOptions(productTemplateId: number | null) {
  // useApi unwraps AxiosResponse.data internally — return api.get(...)
  // directly instead of awaiting+unwrapping ourselves. The fetcher only
  // fires when the key is non-null, so productTemplateId is guaranteed
  // present at call time.
  return useApi<WarrantyOption[]>(
    productTemplateId ? `products/${productTemplateId}/warranty-options` : null,
    () =>
      api.get<WarrantyOption[]>(
        `/api/v1/products/${productTemplateId}/warranty-options`,
      ),
  );
}
